export const REQUEST_PLAYER = 'player/REQUEST_PLAYER';
export const RECEIVE_PLAYER = 'player/RECEIVE_PLAYER';
export const LOGOUT = 'player/LOGOUT';


